module.exports = __webpack_public_path__ + "img/LucasPetrol.8da660c8.jpg";